export enum ModalState {
    View = 'View',
    Create = 'Create',
    Edit = 'Edit',
    Delete = 'Delete',
};
